import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { getReservationsList } from "../../services/reservations/getReservations"; // Importa la función para obtener la lista de reservaciones
import { ReservationCard } from "../../components/ReservationCard";
import { DateWrapper, HeaderContainer, MainHeader, ReservationContainer } from "./styles";
import { CrossContainer } from "../EditUser/styles";
import { Close } from "@mui/icons-material";
import {
  EventIcon,
  EventSubtitle,
  EventTitle,
  EventWithIcon,
  TextContainer,
} from "../../components/Calendar/styles";
import { ReservationListModalProps } from "./types";
import Spinner from "../../components/Spinner/Spinner";

const style = {
  position: "relative",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  height: "auto",
  minWidth: "300px",
  maxHeight: "700px",
  overflow: "auto",
  borderRadius: "20px",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  '@media (max-width: 400px)': {
    p:2,
    height: "90%",
  }
};

const ResourceListModal: React.FC<ReservationListModalProps> = ({
  eventTitle,
  eventDate,
  category,
  category_image,
  dateRange,
}) => {
  // ------------------- JWT -------------------
  const jwt = localStorage.getItem("jwt");
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [formattedEventDate, setFormattedEventDate] = useState<string>("");


  // ------------------- STATES -------------------
  const [reservationsList, setReservationsList] = React.useState<any>([]); // Resources list state

  // ------------------- GET RESOURCES FROM API -------------------
  const getReservations = async () => {
    try {
      const statuses = ["Pending", "In Progress", "Approved", "Completed", "Not available", "Rejected", "Canceled", "Expired"];
      const allReservations = [];

      for (const status of statuses) {
        const res = await getReservationsList(jwt!, status, formattedEventDate, timeZone);
        if (res && res.data && res.data.length > 0) {
          allReservations.push(...res.data);
        }
      }

      if (allReservations.length > 0) {
        allReservations.sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());
        setReservationsList(allReservations);
      }
    } catch (err) {
      // Manejar el error aquí
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  const handleOpen = () => {
    setOpen(true);
    // getReservations();
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (eventDate) {
      const formattedDate = formatDateToYYYYMMDD(eventDate);
      setFormattedEventDate(formattedDate);
    }
  }, [eventDate]);

   // Efecto para obtener la lista de reservaciones cuando se abre el modal
   useEffect(() => {
    if (open && formattedEventDate) {
      getReservations();
    }
  }, [open, formattedEventDate]);


  const statusMapping: { [key: string]: string } = {
    "Completed": "Completada",
    "In Progress": "En progreso",
    "Pending": "Pendiente",
    "Approved": "Aprobada",
    "Not available": "No disponible",
    "Rejected": "Denegada",
    "Canceled": "Cancelada",
    "Modified": "Modificada",
    "Expired": "Vencida",
  };

  const handleStatus = (reservationStatus: string): string => {
    return statusMapping[reservationStatus] || "Desconocido";
  };

  function formatDateString(inputDate: string): { date: string; time: string } {
    const dateObj = new Date(inputDate);

    const year = dateObj.getFullYear().toString().slice(2);
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObj.getDate().toString().padStart(2, "0");

    const date = `${day}/${month}/${year}`;

    const hours = dateObj.getHours().toString().padStart(2, "0");
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");

    const time = `${hours}:${minutes}`;

    return { date, time };
  }

  function formatDateToSpanish(inputDate: any) {
    const dateObj = new Date(inputDate);
    const year = dateObj.getFullYear();
    const monthNames = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ];
    const month = monthNames[dateObj.getMonth()];
    const day = dateObj.getDate();

    return `${day} / ${month} / ${year}`;
  }

  function formatDateToYYYYMMDD(inputDate: string): string {
    const dateObj = new Date(inputDate);
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObj.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  return (
    <div>
      <Button
        onClick={handleOpen}
        style={{ padding: "0px", width: "100%", textAlign: "left" }}
        sx={{
          textTransform: "none",
          justifyContent: "flex-start",
        }}
      >
        <EventWithIcon>
          <EventIcon src={category_image} alt={category_image} />
          <TextContainer>
          <EventTitle> {eventTitle} </EventTitle>
          <EventSubtitle> {dateRange} </EventSubtitle>
          </TextContainer>
        </EventWithIcon>
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <CrossContainer onClick={handleClose}>
            <Close />
          </CrossContainer>
          <HeaderContainer>
            <MainHeader>
              Reservaciones:{" "}
              <DateWrapper>
                {formatDateToSpanish(eventDate)}
              </DateWrapper>
            </MainHeader>
          </HeaderContainer>

          {!loading ? (
            <ReservationContainer>
              {Array.isArray(reservationsList) &&
              reservationsList.length > 0 ? (
                reservationsList.map((reservation: any) => {
                  const { date: startDate, time: startTime } = formatDateString(
                    reservation.start
                  );
                  const { date: endDate, time: endTime } = formatDateString(
                    reservation.finish
                  );
                  const status = handleStatus(reservation.status);

                  return (
                    <ReservationCard
                      key={reservation.id}
                      width="80%"
                      reservation={{
                        resourceId: reservation.resource,
                        resourceName: reservation.resource_name,
                        startDate: startDate,
                        startTime: startTime,
                        endDate: endDate,
                        endTime: endTime,
                        status: status,
                        reservationId: reservation.id,
                      }}
                    />
                  );
                })
              ) : (
                <p>No hay reservaciones</p>
              )}
            </ReservationContainer>
          ) : (
            <Spinner />
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default ResourceListModal;
